<template>
    <div class="image-component-viewer">
        <img v-if="item.image && item.image.publicUrl"
             :src="item.image.publicUrl"
             :style="{
                 width: item.width + 'px',
                 height: item.height + 'px',
                 objectFit: item.objectFit
             }"
             alt="Immagine template" />
        <div v-else class="placeholder-image"
             :style="{
                 width: item.width + 'px',
                 height: item.height + 'px'
             }">
            <icon-image></icon-image>
            <div class="small text-muted mt-1">Immagine</div>
        </div>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as OM from '@/model';

@Options({})
export default class ImageComponentViewer extends Vue {
    @Prop() item: OM.ImageComponent;
}
</script>

<style scoped>
.image-component-viewer img {
    display: block;
}

.placeholder-image {
    border: 2px dashed #dee2e6;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #f8f9fa;
    color: #6c757d;
}
</style>
